window.theme = window.theme || {}
window.theme.autocomplete = window.theme.autocomplete || {}
window.theme.recommendations = window.theme.recommendations || {}
window.theme.results = window.theme.results || {}

window.theme.autocomplete.events = {
  UI: {
    QUERY_UPDATED: 'autocomplete:ui:query:updated',
  },

  API: {
    ACTIVE_TERM_UPDATED: 'autocomplete:api:active-term:updated',
    QUERY_FETCHED: 'autocomplete:api:query:fetched',
    FETCH_FAILED: 'autocomplete:api:fetch:failed',
  },

  STATE: {
    RESPONSE_UPDATED: 'autocomplete:state:response:updated',
  },
  TRACKING: {
    PRODUCT_CLICKED: 'autocomplete:tracking:product:clicked',
    PRODUCT_ADDED_TO_CART: 'autocomplete:tracking:product:added-to-cart',
    KEYWORD_CLICKED: 'autocomplete:tracking:keyword:clicked',
    SUBMIT_SEARCH: 'autocomplete:tracking:submit:search',
  },
}

window.theme.autocomplete.config = {
  categorySize: 5,
  debounceMs: 250,
  keywordSize: 5,
  popularSearchSize: 5,
  productSize: 4,
  storageKey: window.theme.nosto.storageKey,
}

window.theme.results.events = {
  UI: {
    FACET_ADDED: 'listings:ui:facets:added',
    FACET_REMOVED: 'listings:ui:facet:removed',
    FACET_CLEAR_ALL: 'listings:ui:facet:clearAll',
    SORT_CHANGED: 'listings:ui:sort:changed',
    PRICE_CHANGED: 'listings:ui:price:changed',
    PAGINATION_NEXT: 'listings:ui:pagination:next',
    PAGINATION_PREVIOUS: 'listings:ui:pagination:previous',
  },

  API: {
    FETCH_PRODUCTS: 'listings:api:fetch:products',
    PRODUCTS_FETCHED: 'listings:api:products:fetched',
    FACETS_FETCHED: 'listings:api:facets:fetched',
    SHOPIFY_FALLBACK: 'listings:shopify:products:fetched',
  },

  STATE: {
    PRODUCTS_UPDATED: 'listings:state:products:updated',
    FACETS_UPDATED: 'listings:state:facets:updated',
    ACTIVE_FACETS_UPDATED: 'listings:state:activeFacets:updated',
    ACTIVE_SORT_UPDATED: 'listings:state:activeSort:updated',
    PAGINATION_UPDATED: 'listings:state:pagination:updated',
    SEARCH_TOTAL_UPDATED: 'listings:state:searchTotal:updated',
  },

  TRACKING: {
    PRODUCT_CLICKED: 'listings:tracking:product:clicked',
    PRODUCT_ADDED_TO_CART: 'listings:tracking:product:added',
  },
}
